import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import './assests/css/index.css'

import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "./pages/layout/layout";
import { useUserContext } from "./shared/user-context";
import store from "./store/store";
import ErrorBoundary from "./ui/ErrorBoundary";
import Loader from "./ui/Loader";
import { LogStatistics } from "./shared/log";
import { getLogStatistics } from "./shared/client";
import LogStatisticDetails from "./components/log/log-statistics";
import { Status } from "./shared/common";
import ErrorFallbackComponent from "./ui/ErrorFallbackComponent";
  
const App: React.FC<{}> = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { isUserLoggedIn } = useUserContext();
    const [logStatistics, setLogStatistics] = useState<LogStatistics[]>([]);
    const [display, setDisplay] = useState(false);    
    const [status, setStatus] = useState<Status>('idle');
    const [error, setError] = useState<String>("");
    const isLoggedIn = isUserLoggedIn();

    useEffect(()=> {
        setDisplay(location.pathname === "/" ? true : false)
    },[location.pathname])
    
    useEffect(() => {        
        let isMounted = false;
        async function fetchLogStatistics() {
            try {
                if (!isMounted){
                    setStatus("loading")
                    const response = await getLogStatistics();
                    if (typeof response !== 'string') {
                            setStatus("idle")                    
                            setLogStatistics(response)
                    }
                }                
            } catch (error) {
                setStatus("error")
                setError("Error occured fetching data")
                console.error('Error fetching data:', error);
            }
        }

        if (isLoggedIn) {
            fetchLogStatistics()
        }
        else {
            navigate('/login');
        }

        return () => {
            isMounted = true;
        }
    }, [isLoggedIn, navigate])


    return (
        <Provider store={store}>
            <ErrorBoundary FallbackComponent={ErrorFallbackComponent}>
                    <Layout>
                        <React.Suspense fallback={<Loader />}>
                            { error && status === "error" && <p>{error}</p>}
                            { status === "loading" && <Loader/> }
                            {display && isLoggedIn && status === "idle" ?
                                <div className="row justify-content-center">
                                    <div className="col-md-8 align-self-center">
                                        <LogStatisticDetails logStatistics={logStatistics}></LogStatisticDetails>
                                    </div>
                                </div> : null
                            }
                        </React.Suspense>                        
                    </Layout>
                </ErrorBoundary>           
        </Provider>
    );
}

export default App;
